import { Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import logoFicheLab from "src/core/assets/images/logo-fiche-lab.png";

const styles = StyleSheet.create({
  page: {
    padding: 24,
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    width: 172,
    height: 40,
    marginBottom: 24,
  },
  title: {
    fontSize: 26,
    fontWeight: 600,
    color: "#0A1A53",
    textTransform: "uppercase",
    letterSpacing: 4.4,
  },
});

type CoverPageProps = {
  titleTranslationKey: string;
};

/**
 * Page de garde d'un PDF.
 *
 * @param titleTranslationKey - Clé de traduction pour le titre de la page de garde.
 */
export const CoverPage = ({ titleTranslationKey }: CoverPageProps) => {
  const { t } = useTranslation();

  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.container}>
        <Image src={logoFicheLab} style={styles.logo} />
        <Text style={styles.title} wrap={false}>
          {t(titleTranslationKey)}
        </Text>
      </View>
    </Page>
  );
};
